/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 20th August 2018 11:52:12 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

const initialState = () => ({
    integrations: {
        upscribe: {
            settings: {
                enabled: "false"
            }
        }
    }

})

const state = () => (initialState())


const actions = {
    async GET_SETTINGS({ state, commit, dispatch }) {
        try {
            const { integrations } = await dispatch(
                'shopifyApi/REQUEST', 
                {
                    endpoint: 'settings/integrations'
                },
                { root: true }
            )

            if (integrations) {
                commit('SET_INTEGRATIONS', { integrations })

                return integrations
            }

            return null
        } catch (error) {
            console.error(`GET_SETTINGS`, error)
            throw error
        }
    },

    async SAVE_SETTINGS({ state, commit, dispatch }) {
        try {
            const { integrations } = await dispatch(
                'shopifyApi/REQUEST', 
                {
                    method: 'POST',
                    endpoint: 'settings/integrations',
                    data: { integrations: state.integrations }
                },
                { root: true }
            )

            if (integrations) {
                commit('SET_INTEGRATIONS', { integrations })

                return integrations
            }

            return null
        } catch (error) {
            console.error(`SAVE_SETTINGS`, error)
            throw error
        }
    }
}

const mutations = {
    SET_INTEGRATIONS(state, { integrations }) {
        state.integrations = integrations
    },
}

const getters = {
    integrations: state => state.integrations,
}

export default {
    namespaced: true,
    state, actions, mutations, getters
}




// WEBPACK FOOTER //
// ./src/stores/settings-integrations.js